import { useCallback, useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '../store';
import { getAgencyConfig } from '../services/agencyConfig';

/**
 * Loads `intake_manager_columns` from `/agency-config` for the current agency.
 * `stored` is `undefined` until the first fetch completes.
 */
export function useAgencyIntakeManagerColumns(): {
  stored: string[] | null | undefined;
  loading: boolean;
  refresh: () => Promise<void>;
} {
  const agencyId = useStore(useShallow(s => s.user?.agency?.id));
  const [stored, setStored] = useState<string[] | null | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!agencyId) {
      setStored(undefined);
      return;
    }
    setLoading(true);
    try {
      const cfg = await getAgencyConfig();
      setStored(cfg.intake_manager_columns ?? null);
    } catch {
      setStored(null);
    } finally {
      setLoading(false);
    }
  }, [agencyId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { stored, loading, refresh };
}
